import React from 'react';
import TableInc from '../../../../../shared-ui/TableInc';
import { updateExtendedConfig } from "../../../../../lib/requests.es6";

const Premiums = ({ premiums, productGuid, extendedConfig }) => {
  const savePremiums = (updatedPremiums) => {
    const membershipConfig = {
      product_guid: productGuid,
      ...extendedConfig,
      content: {
        ...extendedConfig.content,
        premiums: updatedPremiums,
      },
    };

    return updateExtendedConfig(membershipConfig);
  };

  return (
    <TableInc
      title="Premiums"
      columns={[
        { title: 'Frequency', field: 'frequency' },
        { title: 'CHP', field: 'CHP', type: 'numeric' },
        { title: 'SPOUSE', field: 'SPOUSE', type: 'numeric' },
        { title: 'CHILD', field: 'CHILD', type: 'numeric' },
      ]}
      data={premiums}
      options={{
        showTitle: true,
        pageSize: premiums.length,
        actionsColumnIndex: -1,
        addRowPosition: 'first',
      }}
      editable={{
        onRowAdd: (newData) =>
          new Promise((resolve, reject) => {
            const updatedPremiums = [...premiums, newData];
            savePremiums(updatedPremiums)
              .then((response) => {
                console.log('Premiums updated:', response);
                resolve();
              })
              .catch((error) => {
                console.error('Error updating premiums:', error);
                reject();
              });
          }),
        onRowDelete: (oldData) =>
          new Promise((resolve, reject) => {
            const updatedPremiums = premiums.filter((premium) => premium !== oldData);
            savePremiums(updatedPremiums)
              .then((response) => {
                console.log('Premiums updated:', response);
                resolve();
              })
              .catch((error) => {
                console.error('Error updating premiums:', error);
                reject();
              });
          }),
      }}
    />
  );
};

export default Premiums;